import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';


import {COLUMNS, HEADERS} from 'src/modules/internal-notification/notification-list/constants';
import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';
import {SortField} from 'src/openapi/admin/models/SortField';

import {SortHeaderFilter} from '@pb/kit-component-filters';

import {
    notificationsListStateActions,
    notificationsListStateSelector,
} from '../../slices/notification-search-criteria.slice';

import {NotificationTitleFilter} from './notification-title.filter';

export const NotificationTitleHeader = () => {
    const dispatch = useDispatch();
    const state = useSelector(notificationsListStateSelector);
    const [message, setMessage] = useState(state.filters.title);

    useEffect(() => {
        setMessage(state.filters.title);
    }, [state.filters.title]);

    const applyFilter = useCallback(() => {
        if (state.filters.title !== message) {
            const {title: _title, ...filters} = state.filters;

            dispatch(notificationsListStateActions.setFilters({
                ...filters,
                ...message ? {title: message} : {},
            }));
        }
    }, [dispatch, message, state.filters]);

    const sort = useCallback((direction: 'ASC' | 'DESC') => {
        dispatch(notificationsListStateActions.setSortCriteria(
            {field: SortField.TITLE, direction: direction as SortDirections},
        ));
        applyFilter();
    }, [dispatch, applyFilter]);

    const clearFilter = useCallback(() => {
        const {title: _title, ...filters} = state.filters;
        setMessage(undefined);
        dispatch(notificationsListStateActions.setFilters(filters));
    }, [dispatch, state, setMessage]);

    const cancelFilter = useCallback(() => {
        setMessage(state.filters.title);
    }, [state]);

    return (
        <SortHeaderFilter
            filterActive={!!message}
            sortable={true}
            caption={HEADERS[COLUMNS.TITLE]}
            direction={state.sortCriteria.field === SortField.TITLE
                ? state.sortCriteria.direction
                : undefined}
            defaultDirection={SortDirections.ASC}
            onSort={sort}
            onApply={applyFilter}
            onReset={clearFilter}
            onCancel={cancelFilter}>
            <NotificationTitleFilter
                message={message as string}
                onChange={setMessage}
            />
        </SortHeaderFilter>
    );
};
